export default "__VITE_ASSET__0e75091f__"